import React, { Component } from 'react';
import axios from 'axios'
import { pythonApiIp, toCurrency, getOrderKey } from '../../../../config/constants'
import { Form, Segment, Button, Divider, Feed } from 'semantic-ui-react'
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

function ShowBackupsUi(props) {

    const updateUI = props.backup
        ? <Feed.Event>
            <Feed.Content>
                <Feed.Summary>
                    #{props.index+1} - 
                    <a href={props.backup.url} target="_blank">View</a>
                </Feed.Summary>
                <Feed.Meta>
                    <Feed.Like>
                        {props.backup.dateadded}
                    </Feed.Like>
                </Feed.Meta>
                <Feed.Meta>
                    <Feed.Like>
                    {props.backup.addedby}
                    </Feed.Like>
                </Feed.Meta>
            </Feed.Content>
        </Feed.Event>
        : ''

    return (
        <div>{updateUI}</div>
    )
}

class GetBackUpDesigns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            backups: []
        }
    }

    getDesignBackForOrder = () => {
        console.log("++++++++:getDesignBackForOrder");
        console.log("fbOrderKey:" + getOrderKey(this.props.order))

        if (!getOrderKey(this.props.order)) {
            alert("No projectId sent")
        } else {
            console.log("getting payments data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'getDesignBackForOrder', {
                apiKey: "asdf$sdfd",
                fbOrderKey: getOrderKey(this.props.order),
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        if(response.data.backups.length > 0){
                            console.log("true.. got design backups.");
                            this.setState({
                                backups: response.data.backups
                            })
                        }else{
                            alert("no backups found for "+getOrderKey(this.props.order))
                        }
   
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const showBackupsList =  this.state.backups.map((backup, index) =>

            <ShowBackupsUi key={backup.iddesignbackup} backup={backup} index={index}/>
        );

        const showPaymentsUi = this.state.backups.length > 0
            ? <div>
                <Divider horizontal>{'BACK UPS'}</Divider>
                {showBackupsList}
            </div>
            : ''


        const enterPaymentUI =
            <div>
                {showPaymentsUi}
                <Button color='orange' onClick={this.getDesignBackForOrder} > Show Design Backups</Button>

                
            </div>


        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            {enterPaymentUI}

        </div>);
    }
}

export default GetBackUpDesigns;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/DesignBackup/GetBackUpDesigns.js